import React from "react";
import DataGrid from "./DataGrid";


function DataGridExample() {
  // dataGrid can have one or two buttons for each row
  
  const Button1Action = (id) => {

    alert("you click on button 1, id is " + id);
    //alert("the log action script goes in the app.js logout function");
  };

  const Button2Action = (id) => {

    alert("you click on button 2, id is " + id);
    //alert("the log action script goes in the app.js logout function");
  };

  // fake/example data for datagrid
  const dataGrid = [
    {
      id: "001", // will return on button click, del(001), edit(001)
      label: "long long Name",
      content:
        "firstname middlename lastname, firstname middlename lastname firstname middlename lastname firstname middlename lastname firstname middlename lastname",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "edit", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false, // can be empty, default set to false
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "001a",
      label: "long long Name firstname middlename lastname",
      content: "firstname middlename lastname",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "edit", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false, // can be empty, default set to false
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "001b",
      label: "long long Name",
      content: "firstname middlename lastname",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "edit", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false, // can be empty, default set to false
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "001c",
      label: "long long Name",
      content: "firstname middlename lastname",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "edit", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false, // can be empty, default set to false
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "001d",
      label: "long long Name",
      content: "firstname middlename lastname",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "edit", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false, // can be empty, default set to false
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "002",
      label: "AOD with disable button 1",
      content: "Judith Mahoney",
      contentType: "string", // string,money,phone,email,link
      contentLink: "",
      button1Label: "edit",
      button1IsDisabled: true,
      button1Style: "button button--tertiary",
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "002",
      label: "AOD with disable button 1",
      content: "Judith Mahoney",
      contentType: "string", // string,money,phone,email,link
      contentLink: "",
      button1Label: "edit",
      button1IsDisabled: true,
      button1Style: "button button--tertiary",
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "002",
      label: "AOD with disable button 1",
      content: "Judith Mahoney",
      contentType: "string", // string,money,phone,email,link
      contentLink: "",
      button1Label: "edit",
      button1IsDisabled: true,
      button1Style: "button button--tertiary",
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "002",
      label: "AOD with disable button 1",
      content: "Judith Mahoney",
      contentType: "string", // string,money,phone,email,link
      contentLink: "",
      button1Label: "edit",
      button1IsDisabled: true,
      button1Style: "button button--tertiary",
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "002",
      label: "AOD with disable button 1",
      content: "Judith Mahoney",
      contentType: "string", // string,money,phone,email,link
      contentLink: "",
      button1Label: "edit",
      button1IsDisabled: true,
      button1Style: "button button--tertiary",
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "002",
      label: "AOD with disable button 1",
      content: "Judith Mahoney",
      contentType: "string", // string,money,phone,email,link
      contentLink: "",
      button1Label: "edit",
      button1IsDisabled: true,
      button1Style: "button button--tertiary",
      button2Label: "delete",
      button2Style: "button button--primary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "003",
      label: "Money align to right",
      content: "$4321.99",
      contentType: "money", // string,money,phone,email,link
      contentLink: "",
      button1Label: "pay",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "004",
      label: "disabled button 2",
      content: "123-456-7890",
      contentType: "phone", // string,money,phone,email,link
      contentLink: "",
      button1Label: "call",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: true
    },
    {
      id: "005",
      label: "Total",
      content: "firstname.lastname@childrens.harvard.edu",
      contentType: "email", // string,money,phone,email,link
      contentLink: "",
      button1Label: "email",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "edit",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "006",
      label: "Total",
      content: "https://google.com",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com",
      button1Label: "Edit",
      button1Style: "button button--tertiary",
      button1IsDisabled: false,
      button2Label: "DELETE",
      button2Style: "button button--tertiary",
      button2IsDisabled: false
    },
    {
      id: "007",
      label: "title, link, and button",
      content: "click here",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com",
      button1Label: "go",
      button1Style: "button button--tertiary",
      button1IsDisabled: false
    },
    {
      id: "007",
      label: "title, link, and button",
      content: "click here",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com",
      button1Label: "go",
      button1Style: "button button--tertiary",
      button1IsDisabled: false
    },
    {
      id: "007",
      label: "title, link, and button",
      content: "click here",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com",
      button1Label: "go",
      button1Style: "button button--tertiary",
      button1IsDisabled: false
    },
    {
      id: "007",
      label: "title, link, and button",
      content: "click here",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com",
      button1Label: "go",
      button1Style: "button button--tertiary",
      button1IsDisabled: false
    },
    {
      id: "007",
      label: "title, link, and button",
      content: "click here",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com",
      button1Label: "go",
      button1Style: "button button--tertiary",
      button1IsDisabled: false
    },
    {
      id: "008",
      label: "title and link",
      content: "click here go to google",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com"
    },
    {
      id: "008",
      label: "title and link",
      content: "click here go to google",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com"
    },
    {
      id: "008",
      label: "title and link",
      content: "click here go to google",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com"
    },
    {
      id: "008",
      label: "title and link",
      content: "click here go to google",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com"
    },
    {
      id: "008",
      label: "title and link",
      content: "click here go to google",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com"
    },
    {
      id: "008",
      label: "title and link",
      content: "click here go to google",
      contentType: "link", // string,money,phone,email,link
      contentLink: "https://www.google.com"
    },
    {
      id: "009",
      label: "a very long long long long long long long long title",
      content:
        "a very long long long long long long long long content, a very long long long long long long long long content, a very long long long long long long long long content   ",
      contentType: "string" // string,money,phone,email,link
    },
    {
      id: "009",
      label: "a very long long long long long long long long title",
      content:
        "a very long long long long long long long long content, a very long long long long long long long long content, a very long long long long long long long long content   ",
      contentType: "string" // string,money,phone,email,link
    },
    {
      id: "009",
      label: "a very long long long long long long long long title",
      content:
        "a very long long long long long long long long content, a very long long long long long long long long content, a very long long long long long long long long content   ",
      contentType: "string" // string,money,phone,email,link
    },
    {
      id: "009",
      label: "a very long long long long long long long long title",
      content:
        "a very long long long long long long long long content, a very long long long long long long long long content, a very long long long long long long long long content   ",
      contentType: "string" // string,money,phone,email,link
    },
    {
      id: "009",
      label: "a very long long long long long long long long title",
      content:
        "a very long long long long long long long long content, a very long long long long long long long long content, a very long long long long long long long long content   ",
      contentType: "string" // string,money,phone,email,link
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    },
    {
      id: "010",
      label: "",
      content: "no label, only content and button",
      contentType: "string", // string,money,phone,email,link, empty will default to string
      contentLink: "", // link url for email, link
      button1Label: "add", // if empty, will not show button
      button1Style: "button button--primary", // can be empty, default set to primary
      button1IsDisabled: false // can be empty, default set to false
    }
  ];
 

  return (
    <div>
      {/* <h1>Monthly Call Log Report</h1> */}
      <h2>Data Grid</h2>
      <DataGrid
        data={dataGrid}
        button1Action={(e) => Button1Action(e)}
        button2Action={(e) => Button2Action(e)}
      />

      <br />
      <br />
      <br />
      <hr />

      <h2>Monthly Call Log Report</h2>

      <hr />
      
      <hr />
    </div>
  );
}

export default DataGridExample;
